// Shared helpers for search result highlighting so the coloring stays consistent
// between tables, detail drawers, and dealer-level views.
export const SEARCH_HIGHLIGHT_COLORS = [
  '#4dabf7',
  '#ffb74d',
  '#81c784',
  '#ce93d8',
  '#f06292',
  '#64b5f6',
];

export const getSearchHighlightColor = (index) => {
  if (!Number.isInteger(index)) return null;
  const palette = SEARCH_HIGHLIGHT_COLORS;
  if (!Array.isArray(palette) || palette.length === 0) return null;
  const safeIndex = Math.abs(index) % palette.length;
  return palette[safeIndex];
};

export const buildSearchMatchPayload = (row) => {
  if (!row || typeof row !== 'object') return null;
  const term = typeof row.matchedTerm === 'string' ? row.matchedTerm.trim() : '';
  if (!term) return null;
  const index = Number.isInteger(row.matchedTermIndex) ? row.matchedTermIndex : null;
  return {
    term,
    index,
  };
};
